import { PndType } from "@/enums/enums";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err);
};

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/CanNotAccess",
    name: "canNotAccess",
    component: () => import("@/views/CanNotAccess.vue"),
    meta: { title: "PEAK_Tax" },
  },
  {
    path: "/CanNotAccessMerchant",
    name: "canNotAccessMerchant",
    component: () => import("@/views/CanNotAccessMerchant.vue"),
    meta: { title: "PEAK_Tax" },
  },
  {
    path: "/SessionExpire",
    name: "sessionExpire",
    component: () => import("@/views/SessionExpire.vue"),
    meta: { title: "PEAK_Tax" },
  },
  { path: "*", redirect: "/404", meta: { title: "PEAK  Asset" } },
  {
    path: "/404",
    name: "pageNotFound",
    component: () => import("@/views/PageNotFound.vue"),
    meta: { title: "PEAK_Tax" },
  },
  {
    path: "/",
    name: "login",
    component: () => import("@/views/login/LoginPage.vue"),
    meta: {
      title: "PEAK_Tax",
      noindex: false,
      description: "เข้าสู่ระบบ PEAK Tax ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft",
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/login/LogOut.vue"),
    meta: { title: "PEAK_Tax" },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/Register.vue"),
    meta: {
      title: "PEAK_Tax",
      description:
        "เข้าสู่ระบบ PEAK Tax ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
    },
  },
  {
    path: "/welcome",
    name: "welcome",
    component: () => import("@/views/welcome/Welcome.vue"),
    meta: { title: "Meta_Register" },
  },
  {
    path: "/acceptInvitation",
    name: "acceptInvitation",
    component: () => import("@/views/invitationPage/AcceptInvitation.vue"),
    meta: { title: "Meta_Register" },
  },
  {
    path: "/forgotPwd",
    name: "forgotPwd",
    component: () => import("@/views/forgotPassword/ForgotPassword.vue"),
    meta: {
      title: "Forgot_Password",
      description: "ลิงก์กำหนดรหัสผ่านใหม่จะถูกส่งไปยังอีเมลผู้ใช้งานของคุณ",
    },
  },
  {
    path: "/resetPwd",
    name: "resetPwd",
    component: () => import("@/views/forgotPassword/SetNewPassword.vue"),
    meta: { title: "Forgot_Password" },
  },
  {
    path: "/selectList",
    name: "selectList",
    component: () => import("@/views/selectCompany/SelectList.vue"),
    meta: { title: "select_list" },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/Home.vue"),
    meta: { title: "Menu_Home", breadcrumb: [{ name: "Menu_Home" }] },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/profile/Profile.vue"),
    children: [
      {
        path: "profileSetting",
        name: "profileSetting",
        component: () => import("@/views/profile/profileSetting/ProfileSetting.vue"),
        meta: {
          title: "User_Setting",
          breadcrumb: [{ name: "User_Setting" }],
        },
      },
    ],
  },
  {
    path: "/withholding",
    name: "withholding",
    component: () => import("@/views/withholding/Withholding.vue"),
    meta: { title: "Header_WithHoldingTax", breadcrumb: [{ name: "Header_WithHoldingTax" }] },
    children: [
      {
        path: "withholdingCreate",
        name: "withholdingCreate",
        component: () => import("@/views/withholding/withholdingFullCreate/WithholdingFullCreate.vue"),
        meta: {
          title: "Create_Withholding_Tax",
          breadcrumb: [{ name: "Header_WithHoldingTax", linkName: "withholding" }, { name: "Create_Withholding_Tax" }],
        },
      },
      {
        path: "withholdingEdit",
        name: "withholdingEdit",
        component: () => import("@/views/withholding/withholdingEdit/WithholdingEdit.vue"),
        meta: {
          title: "Edit_Withholding_Tax_Certificate",
          breadcrumb: [
            { name: "Header_WithHoldingTax", linkName: "withholding" },
            { name: "Edit_Withholding_Tax_Certificate" },
          ],
        },
      },
      {
        path: "withholdingDetail",
        name: "withholdingDetail",
        component: () => import("@/views/withholding/withholdingDetail/WithholdingDetail.vue"),
        meta: {
          title: "Header_WithHoldingTax",
          breadcrumb: [{ name: "Header_WithHoldingTax", linkName: "withholding" }],
        },
      },
    ],
  },
  {
    path: "/pnd",
    name: "pnd",
    component: () => import("@/views/pnd/PndTable.vue"),
    meta: { title: "", breadcrumb: [{ name: "" }] },
    children: [
      {
        path: "pnd1",
        name: "pnd1",
        component: () => import("@/views/pnd/pndTable/PNDTable.vue"),
        meta: {
          title: "PND_1",
          breadcrumb: [{ name: "PND_1" }],
        },
      },
      {
        path: "pnd1Create",
        name: "pnd1Create",
        component: () => import("@/views/pnd/PndCreate.vue"),
        meta: {
          title: "PND_1_Form_Create",
          breadcrumb: [
            {
              name: "PND_1_Form",
              linkName: "pnd1",
              query: [{ name: "epti", value: btoa(PndType.PND1.toString()) }],
            },
            { name: "PND_1_Form_Create" },
          ],
        },
      },
      {
        path: "pnd2",
        name: "pnd2",
        component: () => import("@/views/pnd/pndTable/PNDTable.vue"),
        meta: {
          title: "PND_2",
          breadcrumb: [{ name: "PND_2" }],
        },
      },
      {
        path: "pnd2Create",
        name: "pnd2Create",
        component: () => import("@/views/pnd/PndCreate.vue"),
        meta: {
          title: "PND_2_Form_Create",
          breadcrumb: [
            {
              name: "PND_2_Form",
              linkName: "pnd2",
              query: [{ name: "epti", value: btoa(PndType.PND2.toString()) }],
            },
            { name: "PND_2_Form_Create" },
          ],
        },
      },
      {
        path: "pnd3",
        name: "pnd3",
        component: () => import("@/views/pnd/pndTable/PNDTable.vue"),
        meta: {
          title: "PND_3",
          breadcrumb: [{ name: "PND_3" }],
        },
      },
      {
        path: "pnd3Create",
        name: "pnd3Create",
        component: () => import("@/views/pnd/PndCreate.vue"),
        meta: {
          title: "PND_3_Form_Create",
          breadcrumb: [
            {
              name: "PND_3_Form",
              linkName: "pnd3",
              query: [{ name: "epti", value: btoa(PndType.PND3.toString()) }],
            },
            { name: "PND_3_Form_Create" },
          ],
        },
      },
      {
        path: "pnd53",
        name: "pnd53",
        component: () => import("@/views/pnd/pndTable/PNDTable.vue"),
        meta: {
          title: "PND_53",
          breadcrumb: [{ name: "PND_53" }],
        },
      },
      {
        path: "pnd53Create",
        name: "pnd53Create",
        component: () => import("@/views/pnd/PndCreate.vue"),
        meta: {
          title: "PND_53_Form_Create",
          breadcrumb: [
            {
              name: "PND_53",
              linkName: "pnd53",
              query: [{ name: "epti", value: btoa(PndType.PND53.toString()) }],
            },
            { name: "PND_53_Form_Create" },
          ],
        },
      },
      {
        path: "pnd53Detail",
        name: "pnd53Detail",
        component: () => import("@/views/pnd/pndDetail/PndDetail.vue"),
        meta: {
          title: "PND_53",
          breadcrumb: [
            { name: "PND_53", linkName: "pnd53", query: [{ name: "epti", value: btoa(PndType.PND53.toString()) }] },
          ],
        },
      },
      {
        path: "pnd3Detail",
        name: "pnd3Detail",
        component: () => import("@/views/pnd/pndDetail/PndDetail.vue"),
        meta: {
          title: "PND_3",
          breadcrumb: [
            { name: "PND_3", linkName: "pnd3", query: [{ name: "epti", value: btoa(PndType.PND3.toString()) }] },
          ],
        },
      },
      {
        path: "pnd2Detail",
        name: "pnd2Detail",
        component: () => import("@/views/pnd/pndDetail/PndDetail.vue"),
        meta: {
          title: "PND_2",
          breadcrumb: [
            { name: "PND_2", linkName: "pnd2", query: [{ name: "epti", value: btoa(PndType.PND2.toString()) }] },
          ],
        },
      },
      {
        path: "pnd1Detail",
        name: "pnd1Detail",
        component: () => import("@/views/pnd/pndDetail/PndDetail.vue"),
        meta: {
          title: "PND_1",
          breadcrumb: [
            { name: "PND_1", linkName: "pnd1", query: [{ name: "epti", value: btoa(PndType.PND1.toString()) }] },
          ],
        },
      },
    ],
  },
  {
    path: "/pp30",
    name: "pp30",
    component: () => import("@/views/pp30/PP30.vue"),
    meta: { title: "VAT", breadcrumb: [{ name: "VAT" }] },
    children: [
      {
        path: "salesVATItem",
        name: "salesVATItem",
        component: () => import("@/views/pp30/pp30Transaction/SalesVATItem.vue"),
        meta: {
          title: "Sales_Tax_Item",
          breadcrumb: [{ name: "Sales_Tax_Item" }],
        },
      },
      {
        path: "purchaseVATItem",
        name: "purchaseVATItem",
        component: () => import("@/views/pp30/pp30Transaction/PurchaseVATItem.vue"),
        meta: {
          title: "Purchase_Tax_Item",
          breadcrumb: [{ name: "Purchase_Tax_Item" }],
        },
      },
      {
        path: "salesTaxItemDetail",
        name: "salesTaxItemDetail",
        component: () => import("@/views/pp30/pp30Transaction/PP30TransactionDetail.vue"),
        meta: {
          title: "Sales_Tax",
          breadcrumb: [{ name: "Sales_Tax_Item", linkName: "salesVATItem" }],
        },
      },
      {
        path: "purchaseTaxItemDetail",
        name: "purchaseTaxItemDetail",
        component: () => import("@/views/pp30/pp30Transaction/PP30TransactionDetail.vue"),
        meta: {
          title: "Purchase_Tax",
          breadcrumb: [{ name: "Purchase_Tax_Item", linkName: "purchaseVATItem" }],
        },
      },
      {
        path: "form",
        name: "pp30form",
        component: () => import("@/views/pp30/pp30form/PP30FormTable.vue"),
        meta: {
          title: "PP30",
          breadcrumb: [{ name: "PP30" }],
        },
      },
      {
        path: "pp30Create",
        name: "pp30Create",
        component: () => import("@/views/pp30/PP30Create.vue"),
        meta: {
          title: "Home_Create_PP30_Form",
          breadcrumb: [{ name: "PP30", linkName: "pp30form" }, { name: "Home_Create_PP30_Form" }],
        },
      },
      {
        path: "pp30Detail",
        name: "pp30Detail",
        component: () => import("@/views/pp30/pp30Detail/PP30Detail.vue"),
        meta: {
          title: "PP30",
          breadcrumb: [{ name: "PP30", linkName: "pp30form" }],
        },
      },
    ],
  },
  {
    path: "/assets",
    name: "assets",
    component: () => import("@/views/assets/Assets.vue"),
    meta: { title: "assets", breadcrumb: [{ name: "assets" }] },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/contact/Contact.vue"),
    meta: { title: "Contact", breadcrumb: [{ name: "Contact" }] },
    children: [
      {
        path: "ContactDetail",
        name: "contactDetail",
        component: () => import("@/views/contact/ContactDetail.vue"),
        meta: {
          title: "Contact",
          breadcrumb: [{ name: "Contact" }],
        },
      },
    ],
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/views/setting/Setting.vue"),
    meta: { title: "Setting", breadcrumb: [{ name: "Setting" }] },
    children: [
      {
        path: "settingMerchant",
        name: "settingMerchant",
        meta: { title: "Organization_Setting", breadcrumb: [{ name: "Setting" }, { name: "Organization_Setting" }] },
        component: () => import("@/views/setting/settingMerchant/SettingMerchant.vue"),
      },
      {
        path: "settingLogoStamp",
        name: "settingLogoStamp",
        meta: { title: "Logo_And_Stamp", breadcrumb: [{ name: "Setting" }, { name: "Logo_And_Stamp" }] },
        component: () => import("@/views/setting/settingMerchant/SettingMerchantLogoAndStamp.vue"),
      },
      {
        path: "settingConnectPeak",
        name: "settingConnectPeak",
        meta: { title: "Connect_With_PEAK", breadcrumb: [{ name: "Setting" }, { name: "Connect_With_PEAK" }] },
        component: () => import("@/views/setting/SettingMerchantConnectPeak.vue"),
      },
      {
        path: "settingAutoFetchData",
        name: "settingAutoFetchData",
        meta: { title: "Header_AutoFetchData", breadcrumb: [{ name: "Setting" }, { name: "Header_AutoFetchData" }] },
        component: () => import("@/views/setting/SettingAutoFetchData.vue"),
      },
      {
        path: "settingUser",
        name: "settingUser",
        meta: { title: "Menu_UserSetting", breadcrumb: [{ name: "Setting" }, { name: "Menu_UserSetting" }] },
        component: () => import("@/views/setting/settingUser/SettingUser.vue"),
      },
      {
        path: "settingUserDetail",
        name: "settingUserDetail",
        meta: { title: "Menu_UserSetting", breadcrumb: [{ name: "Setting" }, { name: "Menu_UserSetting" }] },
        component: () => import("@/views/setting/settingUser/SettingUserDetail.vue"),
      },
      {
        path: "addUser",
        name: "addUser",
        meta: {
          title: "Add_New_User",
          breadcrumb: [
            { name: "Setting" },
            { name: "Menu_UserSetting", linkName: "settingUser" },
            { name: "Add_New_User" },
          ],
        },
        component: () => import("@/views/setting/settingUser/AddUser.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
